var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMondayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "7 3 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Monday",
    filter: "url(#filter0_dd_2704_49791)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 44",
    x: 8,
    y: 4,
    width: 62,
    height: 62,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5747 47.8238C24.7259 47.8256 23.8917 47.6021 23.1575 47.1761C22.4233 46.75 21.8154 46.1367 21.3958 45.3988C20.9826 44.6661 20.7765 43.8348 20.7997 42.9939C20.8228 42.1531 21.0742 41.3343 21.527 40.6254L30.1329 27.1112C30.5734 26.3849 31.1988 25.7886 31.9451 25.383C32.6915 24.9775 33.5322 24.7773 34.3812 24.803C35.2296 24.8233 36.0574 25.0687 36.7798 25.514C37.5022 25.9593 38.0933 26.5885 38.4927 27.3373C39.2949 28.8543 39.1947 30.6794 38.2338 32.1034L29.6334 45.6176C29.1972 46.2972 28.5966 46.8557 27.8871 47.2414C27.1776 47.627 26.3823 47.8274 25.5747 47.8238Z",
    fill: "#F62B54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.3356 47.8232C38.5998 47.8232 37.0026 46.8951 36.1639 45.4037C35.7517 44.673 35.5461 43.8438 35.5692 43.0052C35.5923 42.1665 35.8433 41.3499 36.2952 40.6431L44.8847 27.1599C45.3186 26.4234 45.9418 25.8164 46.6894 25.4018C47.4371 24.9873 48.282 24.7803 49.1366 24.8024C50.8869 24.8407 52.4732 25.8198 53.2754 27.3513C54.0722 28.8829 53.9555 30.7189 52.9655 32.1393L44.3778 45.6225C43.943 46.2992 43.3448 46.8555 42.6383 47.2401C41.9319 47.6247 41.1399 47.8253 40.3356 47.8232Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M54.7668 47.9369C57.2137 47.9369 59.1973 45.9949 59.1973 43.5993C59.1973 41.2037 57.2137 39.2617 54.7668 39.2617C52.3198 39.2617 50.3362 41.2037 50.3362 43.5993C50.3362 45.9949 52.3198 47.9369 54.7668 47.9369Z",
    fill: "#00CA72"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2704_49791",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2704_49791"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2704_49791",
    result: "effect2_dropShadow_2704_49791"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2704_49791",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMondayIcon);
export default __webpack_public_path__ + "static/media/monday-icon.6519bfe700d74f0177e6f9a54f2a5a33.svg";
export { ForwardRef as ReactComponent };